// Consent-gated Google Analytics (GA4 / gtag.js) helpers.
// Nothing is loaded or tracked until the visitor grants consent via the
// cookie banner. See src/components/CookieConsent.

export const GA_MEASUREMENT_ID = "G-NKHW1FVKK8"
export const CONSENT_COOKIE = "bo-cookie-consent"
const CONSENT_MAX_AGE = 60 * 60 * 24 * 180 // 180 days, in seconds

// Returns "granted", "denied", or null (no choice made yet).
export function getConsent() {
    if (typeof document === "undefined") return null
    const match = document.cookie.match(
        new RegExp("(?:^|; )" + CONSENT_COOKIE + "=([^;]*)")
    )
    return match ? decodeURIComponent(match[1]) : null
}

export function setConsent(value) {
    if (typeof document === "undefined") return
    document.cookie = `${CONSENT_COOKIE}=${value}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`
}

// Clears the stored choice so the consent banner is shown again.
export function resetConsent() {
    if (typeof document === "undefined") return
    document.cookie = `${CONSENT_COOKIE}=; path=/; max-age=0; SameSite=Lax`
}

let loaded = false

// Injects the gtag.js script once, if (and only if) consent has been granted.
// Page views are sent from trackPageview() so first load isn't double-counted.
export function loadGtag() {
    if (loaded || typeof window === "undefined") return
    if (getConsent() !== "granted") return
    loaded = true

    const script = document.createElement("script")
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    function gtag() {
        window.dataLayer.push(arguments)
    }
    window.gtag = gtag
    gtag("js", new Date())
    gtag("config", GA_MEASUREMENT_ID, {
        anonymize_ip: true,
        send_page_view: false,
    })
}

// Records a page view for the given path (SPA route change or first load).
export function trackPageview(path) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return
    window.gtag("config", GA_MEASUREMENT_ID, {
        page_path: path,
        anonymize_ip: true,
    })
}
